import { head } from "lodash";
import utils from "../services/utils";
const mixins = {
  methods: {
    message200() {
      this.$notify({
        type: "success",
        title: "Success",
        message: "Completed!"
      });
    },
    messageDelete() {
      this.$notify({
        type: "success",
        title: "Thành công",
        message: "Xóa thành công!"
      });
    },
    message403(params) {
      var title =
        params !== undefined ? params : "You do not have permission to access!";
      this.$notify.error({
        title: title,
        message: ""
      });
    },
    message404() {
      this.$notify({
        type: "warning",
        title: "Fail",
        message: "404 Not found."
      });
    },
    messageErr() {
      this.$message({
        title: "Lỗi",
        message: "Có lỗi xảy ra",
        type: "error",
        duration: 1000
      });
    },
    message422(errors) {
      let message = [Object.keys(errors)];
      for (let index of message[0]) {
        setTimeout(() => {
          this.$notify({
            title: "Có lỗi xảy ra",
            message: head(errors[index]),
            type: "error",
            duration: 2500
          });
        }, 50);
      }
    },
    notify(title, message, type, duration) {
      this.$notify({
        title: title,
        message: message,
        type: type,
        duration: duration
      });
    },
    message(title, message, type, duration) {
      this.$message({
        title: title,
        message: message,
        type: type,
        duration: duration || 2000,
        showClose: true
      });
    },
    messageError(params) {
      var title = params !== undefined ? params : "Error";
      this.$notify.error({
        title: title,
        message: "Oops! Something went wrong !"
      });
    },
    messageValidate() {
      this.$notify.error({
        title: "Error",
        message: "Check your submit!"
      });
    },
    messageCancel() {
      this.$message({
        type: "info",
        message: "Canceled!"
      });
    },

    checkDeviceIsMobile() {
      return utils.checkDeviceIsMobile();
    }
  }
};
export default mixins;



// WEBPACK FOOTER //
// ./src/mixins/mixin.js